let rootUrl = process.env.REACT_APP_ROOT_URL;

export const ROOT_URL = rootUrl;
export const LOGIN_URL = rootUrl+ '/auth/login';

export const newSectionPageOptions = [
    'Add New Section',
    'Add New Image'
];

export const errorToastrOptions = {
    timeOut: 0,
    removeOnHover: false,
    newestOnTop: true,
    preventDuplicates: true,
};


// WEBPACK FOOTER //
// ./src/config.js